/**
 * Admin service-request queue (M11-T05). Read-only. amtc_admin sees all;
 * hospital_admin sees only their hospital's (enforced server-side).
 */
import { apiFetch } from './client'

export type AdminServiceRequest = {
  reference: string
  status: string
  patient_name: string | null
  patient_phone: string | null
  procedure_name: string
  hospital_name: string
  hospital_slug: string
  price_pesewas: number
  currency: string
  scheduled_for: string
  created_at: string
}

export const SERVICE_REQUESTS_KEY = ['admin', 'service-requests'] as const

/** GET /api/v1/admin/service-requests — newest first. For amtc_admin, an optional
 * `hospitalId` (from the "Managing" picker) scopes to one hospital; omit it for
 * all. Ignored server-side for a hospital_admin (always their own). */
export async function fetchServiceRequests(
  token: string | null,
  hospitalId?: string | null,
  q?: string,
): Promise<AdminServiceRequest[]> {
  const params = new URLSearchParams()
  if (hospitalId) params.set('hospital_id', hospitalId)
  if (q) params.set('q', q)
  const qs = params.toString() ? `?${params.toString()}` : ''
  const body = await apiFetch<{ data: AdminServiceRequest[] }>(
    `/api/v1/admin/service-requests${qs}`,
    { token },
  )
  return body.data
}
